import axios from 'axios';

import { getTierMockByTier } from 'helpers/mock';

import { Tier } from './types';

export const getTier = async (apiDomain: string) => {
  const smilesGetTierUrl = `${apiDomain}/members/v1/members/tier`;
  const JWTToken = localStorage.getItem('session-token');
  const vbzDebug = localStorage.getItem('vbzDebug');

  if (vbzDebug) {
    return getTierMockByTier(vbzDebug);
  }

  return axios
    .get<Tier>(smilesGetTierUrl, {
      headers: {
        Authorization: `Bearer ${JWTToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data)
    .catch((error) => error);
};
